import React, { useState } from "react";
import axios from "config/axios";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Loader from "components/Loader";

const AssignInstructors = ({
  courseId,
  assignedInstructors,
  otherInstructors,
  isInstructorAssigned,
  setIsInstructorAssigned,
}) => {
  const [openModal, setOpenModal] = useState(false);
  const [tabValue, setTabValue] = useState(0); // 0 for Assigned, 1 for Not Assigned
  const [isLoading, setIsLoading] = useState(false);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 1000,
    height: "80vh",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };

  const handleModalOpen = () => {
    setOpenModal(true);
  };

  const handleModalClose = () => {
    setOpenModal(false);
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const assignInstructor = async (instructorId) => {
    try {
      setIsLoading(true);
      const response = await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/api/instructors/assign/${courseId}`,
        { instructorId: instructorId }
      );
      // console.log("Response:", response.data);
      setIsInstructorAssigned(!isInstructorAssigned);
      setIsLoading(false);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const deassignInstructor = async (instructorId) => {
    try {
      setIsLoading(true);
      const response = await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/api/instructors/deassign/${courseId}`,
        { instructorId: instructorId }
      );
      setIsInstructorAssigned(!isInstructorAssigned);
      // console.log("Response:", response.data);
      setIsLoading(false);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  if (!isLoading) {
    return (
      <div>
        <button
          className="bg-green-500 hover:bg-green-400 text-white font-bold py-2 px-4 border-b-4 border-green-700 hover:border-green-500 rounded mr-2"
          onClick={handleModalOpen}
        >
          Edit Instructors
        </button>

        <Modal open={openModal} onClose={handleModalClose}>
          <div
            className="max-h-[80vh] overflow-y-auto bg-white rounded-md p-4"
            style={{
              width: "95%",
              maxWidth: "800px", // optional max width
              margin: "0 auto",
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
          >
            {/* Custom Tabs */}
            <div className="flex border-b border-gray-300 mb-4">
              <button
                className={`px-4 py-2 font-medium text-sm ${tabValue === 0 ? "border-b-2 border-blue-500 text-blue-600" : "text-gray-600"
                  }`}
                onClick={() => handleTabChange(null, 0)}
              >
                Assigned Instructors
              </button>
              <button
                className={`ml-4 px-4 py-2 font-medium text-sm ${tabValue === 1 ? "border-b-2 border-blue-500 text-blue-600" : "text-gray-600"
                  }`}
                onClick={() => handleTabChange(null, 1)}
              >
                Not Assigned Instructors
              </button>
            </div>

            {/* Assigned Instructors Table */}
            {tabValue === 0 && (
              <div className="mt-4 overflow-x-auto">
                <table className="min-w-full text-sm">
                  <thead className="bg-gray-700 text-white">
                    <tr>
                      <th className="text-left px-4 py-2">Name</th>
                      <th className="text-left px-4 py-2">Email</th>
                      <th className="text-left px-4 py-2">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {assignedInstructors.map((instructor) => (
                      <tr key={instructor._id} className="hover:bg-gray-100">
                        <td className="px-4 py-2">{instructor.firstname}</td>
                        <td className="px-4 py-2">{instructor.email}</td>
                        <td className="px-4 py-2">
                          <button
                            onClick={() => deassignInstructor(instructor.user)}
                            className="text-red-600 hover:underline"
                          >
                            Unassign Instructor
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            {/* Not Assigned Instructors Table */}
            {tabValue === 1 && (
              <div className="mt-4 overflow-x-auto">
                <table className="min-w-full text-sm">
                  <thead className="bg-gray-700 text-white">
                    <tr>
                      <th className="text-left px-4 py-2">Name</th>
                      <th className="text-left px-4 py-2">Email</th>
                      <th className="text-left px-4 py-2">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {otherInstructors.map((instructor) => (
                      <tr key={instructor._id} className="hover:bg-gray-100">
                        <td className="px-4 py-2">{instructor.firstname}</td>
                        <td className="px-4 py-2">{instructor.email}</td>
                        <td className="px-4 py-2">
                          <button
                            onClick={() => assignInstructor(instructor.user)}
                            className="text-green-600 hover:underline"
                          >
                            Assign Instructor
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            {/* Close Button */}
            <div className="flex justify-end items-center w-full mt-4">
              <button
                className="bg-green-500 hover:bg-green-400 text-white font-bold py-2 px-4 border-b-4 border-green-700 hover:border-green-500 rounded"
                onClick={handleModalClose}
              >
                Close
              </button>
            </div>
          </div>
        </Modal>
      </div>
    );
  } else {
    return <Loader />;
  }
};

export default AssignInstructors;
